import { useState, useEffect } from 'react';
// SUPABASE SWITCH: revert to '../services/firestore' for Firebase
import { getProjectRole, hasPermission } from '../services/firestore';

const useProjectRole = (userId, projectId) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !projectId) {
      setRole(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    getProjectRole(userId, projectId).then(r => {
      setRole(r || 'editor');
      setLoading(false);
    }).catch(() => {
      setRole('editor');
      setLoading(false);
    });
  }, [userId, projectId]);

  const can = (action) => hasPermission(role, action);

  return { role, loading, can, isAdmin: role === 'admin', isViewer: role === 'viewer' };
};

export default useProjectRole;
